import { render, staticRenderFns } from "./HsabExpenseCardRowRelationships.vue?vue&type=template&id=72b21bb3&scoped=true"
import script from "./HsabExpenseCardRowRelationships.vue?vue&type=script&lang=ts"
export * from "./HsabExpenseCardRowRelationships.vue?vue&type=script&lang=ts"
import style0 from "./HsabExpenseCardRowRelationships.vue?vue&type=style&index=0&id=72b21bb3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b21bb3",
  null
  
)

export default component.exports